import { render, staticRenderFns } from "./UserTypeDisplay.vue?vue&type=template&id=5e8c30b1&scoped=true&"
import script from "./UserTypeDisplay.vue?vue&type=script&lang=js&"
export * from "./UserTypeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8c30b1",
  null
  
)

export default component.exports